<template>
  <div id="dashboardHeader">
    <div
      v-if="env === 'local' && $mq !== 'mobile' && $mq !== 'tablet'"
      class="userName"
    >
      {{ `${user.user.email} (${user.user.role_type})` }}
    </div>

    <ServiceSelection class="header-item" />

    <NotificationDropDown
      v-if="user.user.role_type !== 'OA'"
    />

    <AccountMenu class="header-item" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NotificationDropDown from '../notifications/NotificationsDropDown.vue';
import ServiceSelection from './components/ServiceSelection.vue';

export default {
  components: {
    NotificationDropDown,
    ServiceSelection,
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    env() {
      return process.env.VUE_APP_ENV;
    },
  },

  beforeCreate() {
    // Dynamically load components
    if (process.env.VUE_APP_COMPONENT_ACCOUNT_MENU) {
      this.$options.components.AccountMenu = () => import(
        /* webpackChunkName: "custom" */ process.env.VUE_APP_COMPONENT_ACCOUNT_MENU
      );
    } else {
      this.$options.components.AccountMenu = () => import(
        /* webpackChunkName: "dashboard" */ './components/AccountMenu.vue'
      );
    }
  },

  methods: {
    ...mapActions('user', [
      'logout',
    ]),

    async logoutUser() {
      this.$Progress.start();
      await this.logout();
      this.$router.push({ name: 'login' }).catch((err) => {});
    },

    // async changeLang(lang) {
    //   localStorage.setItem('lang', lang);
    //   this.$i18n.locale = lang;
    // },
  },
};
</script>

<style lang="scss" scoped>
#dashboardHeader {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .userName {
    color: var(--themeFontColor);
    display: inline-block;
    text-decoration: underline;
  }

  text-align: right;
  padding-top: 15px;

  .header-item {
    margin-left: 13px;
  }

  button {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-width: 0;
  }
}
</style>
